import { useDispatch } from 'react-redux'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'
import Actions from '../../../actions'
import { routes, Variant, Origin } from '../../../consts'
import Bot from '../Bot'

import './RiskAssessment.css'

const RiskAssessment = () => {
  const dispatch = useDispatch()

  const onEnd = () => {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        routes.PROFILE_ROUTE.MVP_STATUS
      )
    )
  }

  return (
    <PageCard enableBack={false} className="risk-assesment-bot-page-card">
      <Page className="risk-assesment-bot-page">
        <Bot
          onNext={onEnd}
          outsideVariant={Variant.RISK_ASSESSMENT}
          outsideOrigin={Origin.RISK_ASSESSMENT}
        />
      </Page>
    </PageCard>
  )
}
export default RiskAssessment
